import { css } from "@emotion/css"

type DayProps<T> = {
  day: T
  onDayChange: (day: T) => void
  isSelected: boolean
  display?: (day: T) => string
  disabled?: boolean
}

export function Day<T>(props: DayProps<T>) {
  const { day, onDayChange, isSelected, display, disabled } = props
  const handleClick = () => onDayChange(day)

  return (
    <button
      aria-pressed={isSelected}
      onClick={handleClick}
      disabled={disabled}
      className={css`
        margin: 0;
        padding: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        outline: none;
        border-radius: 4px;

        font-size: 13px;
        background-color: #fff;
        width: var(--w);
        height: var(--h);

        cursor: pointer;
        border-style: solid;
        border-width: 2px;
        border-color: var(--border-color-2);
        transition: border-color 150ms cubic-bezier(0, 0, 0.4, 1);

        :hover,
        :focus {
          background-color: var(--light-grey-2);
        }

        &[aria-pressed="true"] {
          border-color: var(--primary-main);
        }
      `}
    >
      {display ? display(day) : day}
    </button>
  )
}

/* 
::before {
    opacity: 0;
    content: "";
    background-color: transparent;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;

    box-shadow: inset 0px 0px 0px 2px var(--primary-main);
    border-radius: 4px;
    transition: opacity 150ms cubic-bezier(0, 0, 0.4, 1);
  }
*/
